import React from 'react'

import { UBM_ONBOARDING_STATES } from 'constants/ubmOnboarding';

import ChooseOrCreateAdAccount from './ChooseOrCreateAdAccount';

export const ConnectOrCreateAdAccount = () => (
    <ChooseOrCreateAdAccount status={UBM_ONBOARDING_STATES.choose_or_create_ad_account} />
)